<template>
  <iframe
    :src="
      `${this.quoteUrlNew}/app/account/settings?token=${api_token}&lang=${
        $i18n.locale
      }-${
        $i18n.locale === 'fr'
          ? $i18n.locale.toUpperCase()
          : $i18n.locale === 'en'
          ? 'GB'
          : 'SE'
      }`
    "
    :key="$i18n.locale"
    width="100%"
    height="100%"
    style="height:100vh;"
    frameBorder="0"
  />
</template>
<script>
export default {
  metaInfo() {
    return {
      title: 'Account settings',
    };
  },
  data() {
    return {
      quoteUrlNew: process.env.VUE_APP_QUOTES_URL_NEW,
    };
  },
  mounted() {
    window.addEventListener('message', (event) => {
      if (event.origin === this.quoteUrlNew && event.data.startsWith('lang:')) {
        this.$i18n.locale = event.data.replace('lang:', '').split('-')[0];

        localStorage.setItem('lang', this.$i18n.locale);
        document.documentElement.setAttribute(
          'lang',
          this.$i18n.locale.toLowerCase(),
        );
      }
    });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    api_token() {
      return sessionStorage.getItem('api_token');
    },
  },
};
</script>
